import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Menu, MenuItem, Chip } from '@mui/material';
import { Logout, Business, SwapHoriz } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../i18n/LanguageContext';

const DRAWER_WIDTH = 260;

const Navbar: React.FC = () => {
  const { user, logout, companies, currentCompanyId, currentCompanyName, switchCompany } = useAuth();
  const { t } = useLanguage();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleCompanyMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (companies.length > 1) setAnchorEl(event.currentTarget);
  };

  const handleCompanySelect = (companyId: number) => {
    setAnchorEl(null);
    if (companyId !== currentCompanyId) {
      switchCompany(companyId);
    }
  };

  return (
    <AppBar position="fixed" sx={{ width: `calc(100% - ${DRAWER_WIDTH}px)`, ml: `${DRAWER_WIDTH}px` }}>
      <Toolbar>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1 }}>
          <Typography variant="h6" noWrap>{currentCompanyName}</Typography>
          {companies.length > 1 && (
            <Chip
              icon={<SwapHoriz />}
              label={t('company.switch')}
              size="small"
              variant="outlined"
              onClick={handleCompanyMenuOpen}
              sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)', cursor: 'pointer',
                '& .MuiChip-icon': { color: 'white' } }}
            />
          )}
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            {companies.map(c => (
              <MenuItem key={c.id} selected={c.id === currentCompanyId}
                onClick={() => handleCompanySelect(c.id)}>
                <Business sx={{ mr: 1, fontSize: 18 }} /> {c.code} — {c.name}
              </MenuItem>
            ))}
          </Menu>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography variant="body2">{t('common.welcome')}, {user?.username}</Typography>
          <Button color="inherit" startIcon={<Logout />} onClick={logout}>{t('common.logout')}</Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
